import { ProductPageShowcase } from 'src/modules/products/components/ProductPage/ProductPageShowcase';
import { ProductDTO } from 'src/models/pim';
import { ProductPageCrossSell } from 'src/modules/products/components/ProductPage/ProductPageCrossSell';
import { ProductPageBenefitsSection } from 'src/modules/products/components/ProductPage/ProductPageBenefitsSection';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { DictionaryTitlesCode } from 'src/models/pim/dictionaries';
import { ProductPageShowcaseAttribute } from 'src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseAttribute';
import { ProductPageLegalMentions } from 'src/modules/products/components/ProductPage/ProductPageLegalMentions';
import { ProductPageDescriptionSection } from 'src/modules/products/components/ProductPage/ProductPageDescriptionSection';
// import { ProductPageSkincareRoutinesSection } from 'src/modules/products/components/ProductPage/ProductPageSkincareRoutinesSection';
import { ProductPageSctSection } from 'src/modules/products/components/ProductPage/ProductPageSctSection';
import { ProductPageDownloads } from 'src/modules/products/components/ProductPage/ProductPageDownloads';
import { ProductPageSEO } from 'src/modules/products/components/ProductPage/ProductPageSEO';
import { ProductPageIngredientsListSection } from 'src/modules/products/components/ProductPage/ProductPageIngredientsListSection';

export const ProductPageCosmeceuticalsTemplate = (product: ProductDTO) => {
  return (
    <>
      <ProductPageSEO {...product} />

      <ProductPageShowcase product={product}>
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.Volume}
          descriptionCode={ProductAttributeCode.Volume}
        />
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.KeyActiveIngredients}
          descriptionCode={ProductAttributeCode.KeyIngredients}
        />
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.Application}
          descriptionCode={ProductAttributeCode.Application}
        />
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.BeautyTip}
          descriptionCode={ProductAttributeCode.BeautyTip}
        />
      </ProductPageShowcase>

      <ProductPageBenefitsSection
        product={product}
        textCode={ProductAttributeCode.KeyBenefitsText}
        titleCode={ProductAttributeCode.KeyBenefitsTitle}
        dictionaryTitleCode={DictionaryTitlesCode.KeyBenefits}
      />

      <ProductPageBenefitsSection
        product={product}
        textCode={ProductAttributeCode.AestheticIndicationText}
        titleCode={ProductAttributeCode.AestheticIndicationTitle}
        dictionaryTitleCode={DictionaryTitlesCode.AestheticIndications}
      />

      <ProductPageIngredientsListSection
        product={product}
        dictionaryTitleCode={DictionaryTitlesCode.IngredientsList}
        descriptionCode={ProductAttributeCode.Ingredients}
      />

      <ProductPageDescriptionSection
        product={product}
        dictionaryTitleCode={DictionaryTitlesCode.ScienceBehind}
        descriptionCode={ProductAttributeCode.IngredientsEffectivenessText}
      />

      <ProductPageDownloads {...product} />
      <ProductPageSctSection {...product} />
      {/* <ProductPageSkincareRoutinesSection {...product} /> */}
      <ProductPageCrossSell {...product} />
      <ProductPageLegalMentions {...product} />
    </>
  );
};
